import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-settings-overview',
  templateUrl: './settings-overview.component.html',
  styleUrls: ['./settings-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SettingsOverviewComponent implements OnInit {
  page: string = 'overblik';

  constructor(
    activatedRoute: ActivatedRoute,
    private auth: AuthService,
    private router: Router,
  ) {
    if (!this.auth.isAdministrator) {
      this.router.navigate(['forbidden']);
    }

    activatedRoute.fragment.subscribe((p) => {
      if (p) this.page = p;
    });
  }

  ngOnInit(): void {}
}
